import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/AgentsPage.css";

const AgentsPage = () => {
  return (
    <>
      <Header />
      <section className="contentwrapper clearfix" id="agents-page">
        <div className="content agents clearfix">
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Agents</span>
          </div>
          <h1>Agents</h1>
        </div>
      </section>

      <div className="map-comp">
        <iframe
          src="https://www.google.com/maps/d/u/8/embed?mid=1DYMdIbjFkmXCvfyL6F3cW7OqMRgnp0qq"
          width="100%"
          height="480"
          title="Agents Map"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>

        <div style={{ overflowX: "auto" }}>
          <table>
            <thead>
              <tr>
                <th><b>Country</b></th>
                <th><b>Agent</b></th>
                <th><b>Contact person</b></th>
                <th><b>Telephone</b></th>
                <th><b>Email</b></th>
                <th><b>Address</b></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><img src="/wp-content/themes/cdl/images/flags/Belgium.png" className="flag-size" alt="Belgium" /><br />Belgium</td>
                <td><b>ESMA Marine Agencies B.V.</b></td>
                <td>Mr. Cees Onink</td>
                <td>+31 203 121 350 / +31 622 790 463</td>
                <td><a href="cdn-cgi/l/email-protection.html" className="__cf_email__" data-cfemail="2f4c0140414641406f4a5c424e014140">[email&#160;protected]</a></td>
                <td>Kuiperbergweg 35,NL-1101 AE Amsterdam,The Netherlands (EU), P.O. Box 12632, NL-1100 AP Amsterdam, Netherlands</td>
              </tr>
              <tr>
                <td><img src="/wp-content/themes/cdl/images/flags/cyprus.png" className="flag-size" alt="Cyprus" /><br />Cyprus</td>
                <td><b>WSR SERVICES LTD</b></td>
                <td>Mr Thrasos Tsangarides</td>
                <td>+357 99621693 / +357 2535 5518</td>
                <td><a href="cdn-cgi/l/email-protection.html" className="__cf_email__" data-cfemail="731e121a1f5d100a33061e12010400015d101c1e">[email&#160;protected]</a></td>
                <td>234 Ayias Fylaxeos, Amalias Court,2nd floor, P. Box 58019, 3730, Limassol, Cyprus</td>
              </tr>
              <tr>
                <td><img src="/wp-content/themes/cdl/images/flags/germany.png" className="flag-size" alt="Germany" /><br />Germany</td>
                <td><b>COMBITRADE GMBH</b></td>
                <td>Mr. Andreas Schou</td>
                <td>+49 172 453 51 35 / +49 40 80 80 110 600</td>
                <td><a href="cdn-cgi/l/email-protection.html" className="__cf_email__" data-cfemail="ec8f83818e85989e8d8889ac8f83818e85989e8d8889c28889">[email&#160;protected]</a></td>
                <td>COMBITRADE GMBH Caffamacherreihe 720355, Hamburg, Germany</td>
              </tr>
              <tr>
                <td><img src="/wp-content/themes/cdl/images/flags/greece.png" className="flag-size" alt="Greece" /><br />Greece</td>
                <td><b>CHRIS MARINE</b></td>
                <td>Mr Christos Papatheodorou / Mr Kimon Papatheodorou</td>
                <td>+30 210 6773446</td>
                <td><a href="cdn-cgi/l/email-protection.html" className="__cf_email__" data-cfemail="4f3d2a3f2e263d3c0f2c273d263c222e3d26212a612c2022">[email&#160;protected]</a></td>
                <td>CHRIS MARINE SA. 17, Digeni Street 16673, Voula, Athens, Greece</td>
              </tr>
              <tr>
                <td><img src="/wp-content/themes/cdl/images/flags/greece.png" className="flag-size" alt="Greece" /><br />Greece</td>
                <td><b>INTERYARDS S.A.</b></td>
                <td>Vassilis Vassiliou</td>
                <td>+30 693 880 6045 / +30 210 453 1400</td>
                <td><a href="cdn-cgi/l/email-protection.html" className="__cf_email__" data-cfemail="8fe0e9e9e6eceacfe6e1fbeafdf6eefdebfca1ece0e2">[email&#160;protected]</a></td>
                <td>17th km Ethniki Odos Athens & 3 Agrambelis Street, Nea Kifisia, Athens 14563, Greece</td>
              </tr>
              <tr>
                <td><img src="/wp-content/themes/cdl/images/flags/greece.png" className="flag-size" alt="Greece" /><br />Greece</td>
                <td><b>VALMARINE SERVICES S.A.</b></td>
                <td>Mr. Leonidas Valmas</td>
                <td>+30 697 877 1770/ +30 210 428 1532 - 3</td>
                <td><a href="cdn-cgi/l/email-protection.html" className="__cf_email__" data-cfemail="cda4a3aba28dbbaca1a0acbfa4a3a8e3aabf">[email&#160;protected]</a></td>
                <td>72, Pentelis Avenue, Chalandri, Athens 15234, Greece</td>
              </tr>
              <tr>
                <td><img src="/wp-content/themes/cdl/images/flags/japan.png" className="flag-size" alt="Japan" /><br />Japan</td>
                <td><b>ONOMICHI DOCKYARD CO. LTD</b></td>
                <td>Mr. Takanori Zaizen</td>
                <td>+81 78 391 3424</td>
                <td><a href="cdn-cgi/l/email-protection.html" className="__cf_email__" data-cfemail="1662386c777f6c7378567978797b7f757e7f3b726f3875797b">[email&#160;protected]</a></td>
                <td>ONOMICHI DOCKYARD CO. LTD, 104 Edomachi, Cho-ku, Kobe 650-0033, Japan</td>
              </tr>
              <tr>
                <td><img src="/wp-content/themes/cdl/images/flags/norway.png" className="flag-size" alt="Norway" /><br />Norway</td>
                <td><b>HV TRADING</b></td>
                <td>Harald Vinnes / Zeida Blanquicett Guerrero</td>
                <td>+47 915 38192 / +48 516291059</td>
                <td>
                  <a href="cdn-cgi/l/email-protection.html" className="__cf_email__" data-cfemail="6008162008164d14124e030f0d">[email&#160;protected]</a> /{' '}
                  <a href="cdn-cgi/l/email-protection.html" className="__cf_email__" data-cfemail="f8829a9fb89f95998a918c95999b979f91909d9f92959bd69b9795">[email&#160;protected]</a>
                </td>
                <td>Solaasen 2J, N-5223 Nesstun Norway (Bergen area)</td>
              </tr>
              <tr>
                <td><img src="/wp-content/themes/cdl/images/flags/taiwan.png" className="flag-size" alt="Taiwan" /><br />Taiwan</td>
                <td><b>FORTUNE CEYLON SHIPPING AGENCIES PVT LTD</b></td>
                <td>Mr. Young Chen</td>
                <td>+94 769206374 / +1 6266284880 <br /> +886 965663330</td>
                <td><a href="cdn-cgi/l/email-protection.html" className="__cf_email__" data-cfemail="7e18170d16101d16170e0d4f4f4c4e3e19131f1712501d1113">[email&#160;protected]</a></td>
                <td>No. 16, Tianho Street, Qianzhen District, Kaohsiung City, Taiwan, 806</td>
              </tr>
              <tr>
                <td><img src="/wp-content/themes/cdl/images/flags/thailand.png" className="flag-size" alt="Thailand" /><br />Thailand</td>
                <td><b>ECLIPSE MARINE CONSULTANCY & METEOR YACHTS</b></td>
                <td>Mr. Duncan McGregor</td>
                <td>+66 81 893 9127 / +44 78 72222618</td>
                <td><a href="cdn-cgi/l/email-protection.html" className="__cf_email__" data-cfemail="1276677c71737c5277717e7b6261777f73607b7c773c7c7766">[email&#160;protected]</a></td>
                <td>Eclipse Marine Consultancy & Meteor Yachts, Thailand Phuket, Thailand</td>
              </tr>
              <tr>
                <td><img src="/wp-content/themes/cdl/images/flags/united-kingdom.png" className="flag-size" alt="UK" /><br />UK</td>
                <td><b>MMI UK LTD</b></td>
                <td>Mr Michael A McMahon</td>
                <td>+44 7720 074113 / +44 1908 378822</td>
                <td><a href="cdn-cgi/l/email-protection.html" className="__cf_email__" data-cfemail="c2b0a7b2a3abb082afa3b0a3abaca7ecafa3b0a9a7b6abaca5eca1adaf">[email&#160;protected]</a></td>
                <td>G15 Challenge House,Sherwood Drive,Bletchley, Milton Keynes MK3 6DP, United Kingdom.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default AgentsPage;